import { render, staticRenderFns } from "./NoticePassengers.vue?vue&type=template&id=68d5f470&scoped=true"
import script from "./NoticePassengers.vue?vue&type=script&lang=ts"
export * from "./NoticePassengers.vue?vue&type=script&lang=ts"
import style0 from "./NoticePassengers.vue?vue&type=style&index=0&id=68d5f470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d5f470",
  null
  
)

export default component.exports